// extracted by mini-css-extract-plugin
export var linkText = "_md-0";